export const ACCESS_TOKEN = 'Access-Token-MMS'